import ReactDOM from 'react-dom'
import React from 'react'

export default class ReactMounter {
  static REACT_CONTAINER_CSS_SELECTOR = '.js-react-component-container'

  static registeredComponents = {}

  static mountReactComponents() {
    const reactContainersToMount = this.getReactDomContainers()

    reactContainersToMount.forEach((domContainer) => {
      this.mountComponent(domContainer)
    })
  }

  static mountComponent(domContainer) {
    const componentName = domContainer.dataset.componentName
    const componentProps = JSON.parse(domContainer.dataset.componentProps)
    const componentToMount = this.getReactComponent(componentName)

    this.mountReactCompnent(componentToMount, componentProps, domContainer)
  }

  static registerComponentToMountOnLoad(componentName, componentClass) {
    this.registerComponent(componentName, componentClass)

    this.setupDocumentLoadEventListeners()
  }

  static setupDocumentLoadEventListeners() {
    document.addEventListener('turbolinks:load', () => {
      this.mountReactComponents()
    })
  }

  static registerComponent(componentName, componentClass) {
    this.registeredComponents[componentName] = componentClass
  }

  static getReactComponent(componentName) {
    return this.registeredComponents[componentName]
  }

  static mountReactCompnent(ReactComponent, props, domContainer) {
    ReactDOM.render(<ReactComponent {...props} />, domContainer)
  }

  static getReactDomContainers() {
    const reactContainers = document.querySelectorAll(
      this.REACT_CONTAINER_CSS_SELECTOR
    )

    return Array.from(reactContainers)
  }
}
